import { Shift } from "../../schema";
import { weekdayPayCalculator } from "./fpWeekdayPayCalculator";
import { weekendPayCalculator } from "./fpWeekendPayCalculator";
import { ShiftData } from "../common";

// Make sure to only pass in shifts that are submitted
export const fpPayCalculator = async (shifts: Shift[], month: number, year: number, exchangeRate: number | null = null): Promise<ShiftData[]> => {
    const submittedShifts = shifts.filter(shift => shift.submitted);

    const weekdayPay = await weekdayPayCalculator(submittedShifts, month, year);
    const weekendPay = await weekendPayCalculator(submittedShifts, month, year);

    const allShiftData = [...weekdayPay, ...weekendPay];
    
    // Apply exchange rate if provided
    if (exchangeRate) {
        return allShiftData.map(shift => ({
            ...shift,
            pay_due: shift.pay_due* exchangeRate
        }));
    }
    
    return allShiftData;
}